var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/User"),React.createElement("path",{"d":"M7.088 19.055a8.5 8.5 0 1 1 10.819.004c-.406-2.097-2.153-4.559-5.406-4.559-3.299 0-5.02 2.425-5.413 4.555zM12.501 13c1.653 0 2.999-1.346 2.999-3s-1.346-3-3-3c-1.653 0-3 1.346-3 3s1.347 3 3 3z","key":1})]);
}

User.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = User;

User.default = User;
